<rt-dialog-header [heading]="translationKeys[group.kind].header | translate" class="error" />
<rt-dialog-body>
  <div layout layout-align-items-center>
    <rt-avatar
      [shape]="icons[group.kind].shape"
      [iconName]="icons[group.kind].name"
      type="icon"
      customIconBackgroundColor="colorAvatarGrayDark"
      customIconColor="colorIconOncomponentDefault"
      size="base"
    />
    <div layout-vertical margin-left-small>
      <rt-heading>
        {{ group.name }}
      </rt-heading>
      <span>{{
        translationKeys[group.kind].groupMembers | translate: { count: group.membersCount }
      }}</span>
    </div>
  </div>

  <span class="desc" padding-top padding-bottom-small>
    {{ translationKeys[group.kind].desc1 | translate }}
  </span>
  <span class="desc" padding-bottom>
    {{ translationKeys[group.kind].desc2 | translate }}
  </span>

  <rt-group>
    <div class="option-container">
      <rt-checkbox [formControl]="checkboxControl">
        <span class="label">{{ translationKeys[group.kind].checkboxLabel | translate }}</span>
      </rt-checkbox>
    </div>
  </rt-group>
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button
    [disabled]="!checkboxControl.value"
    (click)="confirm()"
    variant="error"
    class="optional"
  >
    {{ translationKeys[group.kind].confirm | translate }}
  </rt-button>
  <rt-button (click)="close()" variant="plain">{{ 'tlc.common.cancel' | translate }}</rt-button>
</rt-dialog-footer>
